<template>
    <div id="sidebar-wrapper" class="full-height">
        <affix class="sidebar sidebar-left full-height" relative-element-selector="#content-wrapper" :offset="{ top: 120, bottom: 0 }">
            <div class="scrollable">
                <div class="header">
                    <h2>{{ group.name }}</h2>
                    <button class="btn btn-tiny" v-on:click.stop.prevent="openModal('new-category')">
                        <i class="icon ion-md-add"></i>
                    </button>
                </div>
                <DraggableTree :data="group.categories" :draggable="true" :space="0" @change="treeChange" v-if="group.categories">
                    <div slot-scope="{data, store}">
                        <template v-if="!data.isDragPlaceHolder">
                            <router-link :to="{ name: 'view-category', params: { group: group.slug, category: data.slug }}" tag="span">
                                <i class="icon ion-md-folder"></i> {{ data.name }}
                            </router-link>
                        </template>
                    </div>
                </DraggableTree>
            </div>
        </affix>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import {DraggableTree} from 'vue-draggable-nested-tree';
    import MicroModal from 'micromodal';

    export default {
        props: [
            'draggable'
        ],
        components: {
            DraggableTree,
        },
        data() {
            return {
                category: {
                    name: null
                },
                activeCategory: null,
                activeClass: 'router-link-exact-active'
            }
        },
        computed: {
            ...mapState({
                group: state => state.group.group,
            })
        },
        created() {
        },
        methods: {
            openModal(modal){
                MicroModal.show(modal);
            },
            changeCategory(slug){
                this.activeCategory = slug;
                this.$emit('change-category', slug);
                //this.$router.push({ name: 'view-category', params: { pageSlug: response.data.breadcrumbs }});
            },
            treeChange(node, nodeVm, store) {
                this.treeJson = nodeVm.pure(nodeVm.rootData, true);
                this.rebuildMenu();
            },
            dragEnd(node, draggableHelperInfo){
                //console.log(this);
                //this.treeJson = store.pure(store.rootData, true).children

                //this.rebuildMenu();
            },
            rebuildMenu() {
                var categories = this.treeJson.children;
                var url = '/api/groups/' + this.$route.params.group + '/categories/rebuild-menu';

                axios.post(url, {categories: categories}).then((response) => {
                    this.group = response.data;
                    
                }, (response) => {
                    this.error = response;
                });
            }
        }
    }
</script>